export const calculateHours = (total, rest) => {
    if (total >= rest) {
        return total - rest;
    }
}
